import React from 'react';
import { useTheme } from '../context/ThemeContext';

function SkeletonBlock({ height = 'h-4', width = 'w-full', className = '' }) {
  const { colors } = useTheme();
  return (
    <div
      className={`animate-pulse rounded-lg ${height} ${width} ${className}`}
      style={{ backgroundColor: colors.inputBg }}
    />
  );
}

// Full page skeleton — mimics a header + list of cards
export function PageSkeleton() {
  const { colors } = useTheme();
  return (
    <div className="space-y-4 animate-pulse">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg" style={{ backgroundColor: colors.inputBg }} />
        <div className="space-y-1.5 flex-1">
          <div className="h-5 w-36 rounded-lg" style={{ backgroundColor: colors.inputBg }} />
          <div className="h-3 w-24 rounded-lg" style={{ backgroundColor: colors.inputBg }} />
        </div>
      </div>
      {/* Cards */}
      {[80, 64, 80, 56, 72].map((h, i) => (
        <div key={i} className={`w-full rounded-2xl`} style={{ height: h, backgroundColor: colors.inputBg }} />
      ))}
    </div>
  );
}

// List of card skeletons — for orders, trades, history
export function CardListSkeleton({ count = 3, height = 'h-16' }) {
  const { colors } = useTheme();
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`w-full rounded-2xl animate-pulse ${height}`}
          style={{ backgroundColor: colors.inputBg }} />
      ))}
    </div>
  );
}

// Stat grid skeleton — for analytics / discipline summary cards
export function StatGridSkeleton({ count = 4 }) {
  const { colors } = useTheme();
  return (
    <div className="grid grid-cols-2 gap-2">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl p-4 animate-pulse space-y-2"
          style={{ backgroundColor: colors.inputBg }}>
          <div className="h-3 w-16 rounded" style={{ backgroundColor: colors.border }} />
          <div className="h-6 w-20 rounded" style={{ backgroundColor: colors.border }} />
          <div className="h-2.5 w-14 rounded" style={{ backgroundColor: colors.border }} />
        </div>
      ))}
    </div>
  );
}

// Detail page skeleton — for stock detail, trade detail
export function DetailPageSkeleton() {
  const { colors } = useTheme();
  return (
    <div className="space-y-4 animate-pulse">
      {/* Back + title */}
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg" style={{ backgroundColor: colors.inputBg }} />
        <div className="space-y-1.5">
          <div className="h-5 w-28 rounded-lg" style={{ backgroundColor: colors.inputBg }} />
          <div className="h-3 w-20 rounded-lg" style={{ backgroundColor: colors.inputBg }} />
        </div>
      </div>
      {/* Hero card */}
      <div className="w-full h-28 rounded-2xl" style={{ backgroundColor: colors.inputBg }} />
      {/* Stat row */}
      <div className="grid grid-cols-3 gap-2">
        {[1,2,3].map(i => (
          <div key={i} className="h-16 rounded-xl" style={{ backgroundColor: colors.inputBg }} />
        ))}
      </div>
      {/* Content blocks */}
      {[96, 72, 112].map((h, i) => (
        <div key={i} className="rounded-2xl" style={{ height: h, backgroundColor: colors.inputBg }} />
      ))}
    </div>
  );
}

export default SkeletonBlock;
